
import * as _ from "lodash";
import moment from "moment";

import * as C from '../controls/constraints.jsx';

import {
    $grades, $stdLanguages, $stdHealthGroups, $isFirstPoDict, $stdEducationDocumentTypes, $additionalStatusTypes, $stdEducationPrioSubjects,
    $representativePersonList
} from "./Dictionaries.jsx";


function doctype_is_passport(data, root) {
    return (root.document_type == 'passport-rf') ? true : null;
}

function doctype_is_other(data, root) {
    return (root.document_type == 'passport-other') ? true : null;
}

function splitFullName(name) {
    return _.split(name, /\s+/g);
}


class AvgGradeCalculator extends C.AbstractConstraint {
    mangle_value(data, root) {
        if(!root['education_count_3'] || !root['education_count_4'] || !root['education_count_5']) return '';
        return ((
                (Number(root['education_count_3']) * 3) +
                (Number(root['education_count_4']) * 4) +
                (Number(root['education_count_5']) * 5)
            ) /
            (
                Number(root['education_count_3']) +
                Number(root['education_count_4']) +
                Number(root['education_count_5'])
            )).toFixed(2);
    }
}


class PriorityGradeSumCalculator extends C.AbstractConstraint {
    mangle_value(data, root) {
        return _.reduce(root.education_prio_subjects, function(r, v) {
            return r + ((typeof v.value != 'undefined' && v.value !== null) ? v.value : NaN);
        }, 0);
    }
}


export default C.prepareConstraint({
    '_document_uid': new C.DefaultValue(null),
    '_version': new C.DefaultValue(2),
    // page0 = /
    'persdata_accepted': [
        new C.DefaultValue(false),
        new C.NotEmptyConstraint('Необходимо подтвердить согласие'),
        new C.ValueEqualConstraint(true, 'Необходимо подтвердить согласие')
    ],
    'persdata_accepted_at': [
        new C.ComputeValue(function(value, root) {
            const pda = root['persdata_accepted'];

            if(pda) {
                return value?value:new Date();

            } else {
                return null;

            }
            
        })
    ],
    // page1 = /start
    'full_name': [
        new C.NotEmptyConstraint('Введите ваше полное имя по паспорту'),
        new C.ValidFullNameConstraint('Фамилия Имя Отчество')
    ],
    'contact_phone': [
        new C.NotEmptyConstraint('Введите контактный телефон'),
        new C.ValidPhoneConstraint('Возможно, номер телефона введён некорректно')
    ],
    'specialization': [
        new C.DefaultValue([]),
        new C.LengthRangeConstraint(1, 3, 'Выберите от одного до трёх направлений')
    ],

    // page2 = /docs
    'document_type': [
        new C.NotEmptyConstraint('Выберите документ')
    ],
    'document_type_display': [
        new C.ComputeValue(function(value, root) {
            return root['document_type'];
        })
    ],
    
    'passport_no': new C.SingleConstraintGroup(
        [
            new C.NotEmptyConstraint('Введите номер паспорта')
        ],
        null,
        doctype_is_passport
    ),
    'passport_issued_at': new C.SingleConstraintGroup(
        [
            new C.NotEmptyConstraint('Введите дату выдачи'),
            new C.ValidDateConstraint('Введите правильную дату (ДД.ММ.ГГГГ)')
        ],
        null,
        doctype_is_passport
    ),
    'passport_code': new C.SingleConstraintGroup(
        [
            new C.NotEmptyConstraint('Введите код подразделения')
        ],
        null,
        doctype_is_passport
    ),
    'passport_issued_by': new C.SingleConstraintGroup(
        [
            new C.NotEmptyConstraint('Введите наименование органа, выдавшего паспорт')
        ],
        null,
        doctype_is_passport
    ),
    
    'document_description': new C.SingleConstraintGroup(
        [
            new C.NotEmptyConstraint('Введите информацию о документе, удостоверяющем личность')
        ],
        null,
        doctype_is_other
    ),
    'citizenship': [
        new C.ExplicitValue(
            'Российская Федерация',
            null,
            doctype_is_passport
        ),
        new C.SingleConstraintGroup(
            [
                new C.NotEmptyConstraint('Укажите ваше гражданство')
            ],
            null,
            doctype_is_other
        )
    ],

    'tax_id': [
        new C.ValidTaxIdConstraint('Ошибка в номере ИНН')
    ],
    'ssn_id': [
        new C.NotEmptyConstraint('Введите СНИЛС'),
        new C.ValidSsnConstraint('Ошибка в номере СНИЛС')
    ],

    'birth_date': [
        new C.NotEmptyConstraint('Введите вашу дату рождения'),
        new C.ValidDateConstraint('Введите корректную дату (ДД.ММ.ГГГГ)')
    ],
    'birth_place': [
        new C.NotEmptyConstraint('Укажите место рождения')
    ],
    'address_reg': [
        new C.NotEmptyConstraint('Введите адрес регистрации по паспорту')
    ],
    'address_reg_is_living': [

    ],
    'address_living': [
        new C.CopyValue(
            'address_reg',
            null,
            function(data, root) {
                return root.address_reg_is_living ? true : null;
            }
        ),
        new C.SingleConstraintGroup([
                new C.NotEmptyConstraint('Введите адрес проживания')
            ],
            'Укажите адрес проживания',
            function(data, root) {
                return root.address_reg_is_living ? null : true;
            }
        )
    ],

    // page3 = /education
    'education_org': [
        new C.NotEmptyConstraint('Введите наименование общеобразовательного учреждения')
    ],
    'education_finished_at': [
        new C.ComputeValue(function(value, root) {
            let date = root['education_document_issue_date'];
            if(typeof date === 'undefined' || date === null || !date.length) return value;

            date = moment(date, 'DD.MM.YYYY', true);
            if(!date.isValid()) return value;

            return date.year();
        })
        //,new C.NotEmptyConstraint('Введите год окончания')
    ],
    'education_document_type': [
        new C.NotEmptyConstraint('Выберите тип документа')
    ],
    'education_document_type_display': [
        new C.ComputeValue(function(value, root) {
            let el = _.find($stdEducationDocumentTypes.get(), {value:root['education_document_type']});
            return el ? el.label : null;
        })
    ],
    'education_document_number': [
        new C.NotEmptyConstraint('Введите серию(при наличии) и номер документа')
    ],
    'education_document_issue_date': [
        new C.NotEmptyConstraint('Укажите дату выдачи'),
        new C.ValidDateConstraint('Введите корректную дату (ДД.ММ.ГГГГ)')
    ],
    'education_document_red': [
    ],
    'education_languages': [
    ],
    'education_languages_display': [
        new C.ComputeValue(function(value, root) {
            let vals = (root['education_languages'] || []);
            vals = _.map(vals, (val) => _.find($stdLanguages.get(), { value: val })||{});
            return _.map(vals, (val) => val.label);
        })
    ],

    'education_count_5': [
        new C.NotEmptyConstraint('Укажите количество оценок'),
        new C.ValidNumberConstraint('Укажите количество оценок')
    ],
    'education_count_4': [
        new C.NotEmptyConstraint('Укажите количество оценок'),
        new C.ValidNumberConstraint('Укажите количество оценок')
    ],
    'education_count_3': [
        new C.NotEmptyConstraint('Укажите количество оценок'),
        new C.ValidNumberConstraint('Укажите количество оценок')
    ],
    'education_avg_grade': [
        new AvgGradeCalculator()
    ],

    'education_prio_subjects': [
        new C.DefaultValue(() => (
            _.map(
                $stdEducationPrioSubjects.get(),
                (v) => ({"title": v, "value": null})
            )
        )),
        new C.ArrayConstraintGroup(
            new C.ObjectSchemaConstraint({
                title: [
                    new C.NotEmptyConstraint('Неверный параметр')
                ],
                value: [
                    new C.NotEmptyConstraint('Укажите оценку')
                ]
            }),
            null,
            function(data, root) {
                return (typeof root.specialization != 'undefined' && root.specialization !== null) ? true : null;
            },
            function(r) {
                if(r.total > 0 && r.invalid > 0) r.r = false;
                return r;
            }
        )
    ],
    'education_prio_subject_sum': new C.SingleConstraintGroup(
        [
            new PriorityGradeSumCalculator()
        ],
        null,
        function(data, root) {
            return (typeof root.specialization != 'undefined' && root.specialization !== null) ? true : null;
        }
    ),

    // page3 = /parents
    'representatives': [
        new C.DefaultValue(() => (
            _.map(
                $representativePersonList.get(),
                (v) => (
                    {status: v}
                )
            )
        )),
        new C.ArrayConstraintGroup(
            new C.ObjectSchemaConstraint({
                'status': [
                    new C.NotEmptyConstraint()
                ],
                'full_name': [
                    new C.NotEmptyConstraint('Введите полные фамилию, имя и отчество'),
                    new C.ValidFullNameConstraint('Введите корректные фамилию, имя и отчество')
                ],
                'contact_phone': [
                    new C.NotEmptyConstraint('Введите номер телефона'),
                    new C.ValidPhoneConstraint('Возможно, номер телефона некорректен')
                ],
                'address_living': [
                    new C.NotEmptyConstraint('Укажите адрес проживания')
                ],
                'work_organization': [
                    new C.NotEmptyConstraint('Введите место работы')
                ],
                'work_position': [
                ]
            }),
            null, null, function(r) {
                if(r.invalid < r.total) r.r = true;
                if(r.total == 0) r.r = false;
                return r;
            }
        )
    ],

    // page4 = /more
    'health_group': [
        new C.NotEmptyConstraint()
    ],
    'health_group_display': [
        new C.ComputeValue(function(value, root) {
            let el = _.find($stdHealthGroups.get(), {value:root['health_group']});
            return el ? el.label : null;
        })
    ],
    'is_first_po': [
        new C.NotEmptyConstraint()
    ],
    'is_first_po_display': [
        new C.ComputeValue(function(value, root) {
            let el = _.find($isFirstPoDict.get(), {value: root['is_first_po']});
            return el ? el.label : null;
        })
    ],
    'special_status': [
    ],
    'special_status_display': [
        new C.ComputeValue(function(value, root) {
            let
                dict = $additionalStatusTypes.get()||[],
                vals = (root['special_status'] || []);
            vals = _.map(vals, (val) => _.find(dict, { value: val })||{});
            vals = _.map(vals, (val) => val.label);
            return vals;
        })
    ],
    'additional_info': [
    ],

    // page4 = /contacts
    'contact_phone_alt': [
        new C.ValidPhoneConstraint('Возможно, номер телефона некорректен')
    ],
    'contact_email': [
    ],
    'contact_social': [
    ]
});
